import { SAVE_SCHEMA_VERSION } from './schema/v1';

/** content-schemas §11.6. Each migration is a pure function on raw JSON and has a fixture test. */
export interface Migration {
  from: number;
  to: number;
  migrate: (raw: Record<string, unknown>) => Record<string, unknown>;
}

export const MIGRATIONS: readonly Migration[] = [];
export const LATEST_SCHEMA_VERSION = SAVE_SCHEMA_VERSION;

export class SaveFormatError extends Error {
  override name = 'SaveFormatError';
}

/** A save written by a newer app version: never touch it, ask the player to update. */
export class SaveFromFutureError extends Error {
  override name = 'SaveFromFutureError';
  constructor(readonly version: number) {
    super(`Save schema ${version} is newer than this app (${LATEST_SCHEMA_VERSION})`);
  }
}

export function migrate(raw: unknown, migrations: readonly Migration[] = MIGRATIONS): unknown {
  if (raw === null || typeof raw !== 'object') throw new SaveFormatError('save is not an object');
  let cur = raw as Record<string, unknown>;
  let v = Number(cur.schemaVersion);
  if (!Number.isInteger(v) || v < 1) throw new SaveFormatError('invalid schemaVersion');
  if (v > LATEST_SCHEMA_VERSION) throw new SaveFromFutureError(v);
  while (v < LATEST_SCHEMA_VERSION) {
    const m = migrations.find((x) => x.from === v);
    if (!m) throw new SaveFormatError(`missing migration ${v}→${v + 1}`);
    cur = { ...m.migrate(structuredClone(cur)), schemaVersion: m.to };
    v = m.to;
  }
  return cur;
}
